import React, { useState, useMemo } from 'react';

import * as Yup from 'yup';

import { Report } from '~/components';
import { Autocomplete, Input, Select, RadioGroup } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function RelEquipamento() {
  const [open, setOpen] = useState(true);

  const optionsType = [
    {
      label: t('s.relatorio.geral.todos'),
      value: 'T',
    },
    {
      label: t('s.geral.opcoes.liberado'),
      value: 'L',
    },
    {
      label: t('s.geral.opcoes.bloqueado'),
      value: 'B',
    },
  ];

  const cellsCompany = useMemo(
    () => [
      {
        id: 'idempresaveiculo',
        label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsVehicle = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.configuracao.comboio.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.menu.cadastro.veiculo.modelo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsLocomotiva = [
    {
      id: 'idtipolocomotiva',
      label: 'ID',
    },
    {
      id: 'nometipolocomotiva',
      label: t('s.geral.tipoequipamento'),
    },
  ];

  function handleSerializeForm(params) {
    return {
      ...params,
      statusveiculo: params.statusveiculo?.value || params.statusveiculo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.relequipamento')}
      relatorio="relequipamento"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        statusveiculo: 'T',
      }}
    >
      <PesquisaTabela
        name="idempresaveiculo"
        label={t('s.menu.cadastro.veiculo.empresa')}
        primary="idempresaveiculo"
        secondary="nomeempresaveiculo"
        url="empresasveiculos"
        header={cellsCompany}
      />
      <PesquisaTabela
        name="idveiculo"
        label={t('s.menu.cadastro.mensagem.equipamentoamensagemsistema')}
        primary="idveiculo"
        secondary="nomemodeloveiculo"
        url="veiculos"
        header={cellsVehicle}
      />
      {/*
      <Autocomplete
        name="idtipolocomotiva"
        unique="idtipolocomotiva"
        label="nometipolocomotiva"
        title={t('s.geral.tipoequipamento')}
        url="veiculos/locomotivas"
      /> */}
      <PesquisaTabela
        name="idtipolocomotiva"
        label={t('s.geral.tipoequipamento')}
        primary="idtipolocomotiva"
        secondary="nometipolocomotiva"
        url="tipolocomotiva"
        header={cellsLocomotiva}
      />
      <Select
        name="statusveiculo"
        variant="outlined"
        size="small"
        label={t('s.configuracao.posto.statusposto')}
        options={optionsType}
        defaultValue="T"
      />
      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelEquipamento;
